import createLucideIcon from '../createLucideIcon';

const SignalZero = createLucideIcon('SignalZero', [
  ['path', { d: 'M2 20h.01', key: '4haj6o' }],
]);

export default SignalZero;
